import { render, staticRenderFns } from "./FeeScheduleAndRatesDeepLink.vue?vue&type=template&id=6ba5cbe0"
import script from "./FeeScheduleAndRatesDeepLink.vue?vue&type=script&lang=ts"
export * from "./FeeScheduleAndRatesDeepLink.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports